module.exports = __webpack_public_path__ + "img/add2.3a45e468.svg";